module.exports = __webpack_public_path__ + "static/img/热烈庆祝北京飞猪科技@2x.911343f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/热烈庆祝北京飞猪科技@2x.png
// module id = iT5P
// module chunks = 0